<style lang="less" scoped>
.headline-box {
  padding: 0.2667rem 0;
  .headline-t-s {
    padding: 0 0.4rem /* 30/75 */;
  }
  .headline-searchel {
    margin: 0.2667rem /* 20/75 */ 0;
  }
  .headline-list {
  }
}
</style>

<template>
  <div class="headline-box">
    <div class="headline-top">
      <ButtonTab
        class="headline-t-s"
        :textList="['头条资讯', '病例分享']"
        @button-tab-change="tabChange"
        :defaultIndex="0"
      ></ButtonTab>
      <SearchEl
        class="headline-searchel"
        :type="componentName === 'Information' ? 1 : 2"
      >
        <Tabs
          style="margin:0.32rem 0"
          slot="tabs"
          :list="bingliCategoryList"
          v-if="componentName === 'Bingli'"
        ></Tabs>
      </SearchEl>
    </div>

    <div class="headline-list" @touchmove="preLoad(getPre)">
      <component :is="componentName" :list="list"></component>
      <p style="text-align:center;margin-top: 1rem" v-show="!list.length">
        <inline-loading></inline-loading>
        <span
          style="vertical-align:middle;display:inline-block;font-size:14px;"
        >
          &nbsp;&nbsp;加载中
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import SearchEl from '@/components/Search/searchEl.vue';
import ButtonTab from '@/components/ButtonTab.vue';
import Information from '@/components/Headline/Information.vue';
import Bingli from '@/components/Headline/Bingli.vue';
import Tabs from '@/components/Headline/Tabs.vue';
import { headline } from '@/api/ajax.js';
import { loadMore } from '@/Mixin/loadMore.js';
export default {
  name: '',
  mixins: [loadMore],
  data() {
    return {
      params: {
        pageNo: 1,
        pageSize: 20
      },
      list: [],
      loadFlag: true,
      componentName: 'Information',
      bingliCategoryList: [],
      source: null
    };
  },
  methods: {
    ...mapMutations(['ISBUTTONACTIVE']),
    tabChange(v) {
      this.source.cancel('请求取消');

      this.list = [];
      this.params.pageNo = 1;
      this.componentName = !v ? 'Information' : 'Bingli';
      this.loadFlag = true;
      this.getPre();
      this.ISBUTTONACTIVE(this.componentName);
      // console.log(this.isButtonActive);
    },
    info() {
      //初始化滑动
      this.courseList = [];
      this.params.pageNo = 1;
      this.loadFlag = true;
    },
    getList(data) {
      if (this.loadFlag) {
        this.loadFlag = false;
        let listAjax =
          headline[
            this.componentName === 'Information' ? 'newList' : 'contentList'
          ];
        this.source = this.$http.CancelToken.source();
        listAjax(data, {
          cancelToken: this.source.token
        })
          .then(res => {
            let respList = res.data.data.list;
            for (var i = 0; i < respList.length; i++) {
              this.list.push(respList[i]);
            }
            if (respList.length < this.params.pageSize) {
              this.loadFlag = false;
              return false;
            }
            this.params.pageNo += 1;
            this.loadFlag = true;
          })
          .catch(res => {
            // console.log(res)
            // 如果调用了cancel方法，那么这里的res就是cancel传入的信息
            // 你的逻辑
          });
        // console.log(this.source.cancel)
      }
    },
    getPre() {
      this.getList(this.params);
    }
  },
  computed: {
    ...mapState({
      isButtonActive: state => state.isButtonActive
    })
  },
  components: {
    ButtonTab,
    SearchEl,
    Information,
    Bingli,
    Tabs
  },
  created() {
    let a = (data, status) => {
      console.log(data, status, '---');
    };
    let e = 5,
      f = { f: 1 };
    a({ a: 1, b: 2, e, f }, { c: 3, d: 4 });
    if (this.isButtonActive) {
      this.componentName = this.isButtonActive;
    }
    this.getPre();
    headline
      .bingliCategory({
        pageNo: 1,
        pageSize: 100
      })
      .then(res => {
        this.bingliCategoryList = res.data.data;
        // console.log(this.bingliCategoryList);
      });
  }
};
</script>
